import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkDelete: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBookmarkDelete"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22.2704L12 17.8566L20 22.2704V2H4ZM15.3588 7.70645L13.0607 10.0045L15.3588 12.3026L14.2981 13.3633L12 11.0652L9.7019 13.3633L8.64124 12.3026L10.9393 10.0045L8.64124 7.70645L9.7019 6.64579L12 8.94389L14.2981 6.64579L15.3588 7.70645Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkDelete;
